module.exports = __webpack_public_path__ + "img/passenger_details_icon.bd82ded3.png";